import type { UserPlan } from "./plans";

/** Maximum history depth in seconds per plan (pro = unlimited) */
export const PLAN_MAX_RANGE_SEC: Record<UserPlan, number> = {
  anonymous: 7 * 86_400,   // 7 days
  free: 90 * 86_400,       // 3 months
  pro: Infinity,           // all data
  studio: Infinity,        // all data
};
